module.exports = __webpack_public_path__ + "static/media/athlete2.6d53898d.png";